import { Session } from '@/models/session';
import { SessionService } from '@/services/sessions';
import { errorCatch } from '../utils';

const sessionService = new SessionService();

export const state = {
  sessions: [],
  loading: false,
  error: {}
};

export const mutations = {
  ADD_SESSION(state: any, payload: Session) {
    state.sessions.push(payload);
  },

  SET_SESSIONS(state: any, payload: Session[]) {
    state.sessions = payload;
  },

  UPDATE_SESSION(state: any, payload: Session) {
    const index = state.sessions.findIndex(
      (session: Session) => session.id === payload.id
    );
    state.sessions.splice(index, 1, payload);
  },

  REMOVE_SESSION(state: any, payload: number) {
    const index = state.sessions.findIndex(
      (session: Session) => session.id === payload
    );
    state.sessions.splice(index, 1);
  },
  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },
  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),
  createSession: async ({ commit, dispatch }: any, payload: Session) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      sessionService
        .createSession(payload)
        .then(session => {
          commit('ADD_SESSION', session);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchSessions: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      sessionService
        .fetchSessions()
        .then(sessions => {
          commit('SET_SESSIONS', sessions);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchSession: async ({ commit, state, dispatch }: any, payload: number) => {
    dispatch('clearError');

    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      sessionService
        .fetchSession(payload)
        .then(session => {
          const sessions = [...state.sessions];
          const index = sessions.findIndex((s: Session) => s.id === payload);
          if (index === -1) {
            commit('ADD_SESSION', session);
          } else {
            commit('UPDATE_SESSION', session);
          }
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  updateSession: async ({ commit, dispatch }: any, payload: Session) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      sessionService
        .updateSession(payload.id, payload)
        .then(session => {
          commit('UPDATE_SESSION', session);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  deleteSession: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');

    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      sessionService
        .deleteSession(payload)
        .then(() => {
          commit('REMOVE_SESSION', payload);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);

          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getSessionById: (state: any) => (id: number) => {
    return state.sessions.find((session: Session) => session.id === id);
  }
};
